
<template>
    <div class="view">
      <quill-editor
        class="ql-editor"
        v-model="content"
        ref="myQuillEditor"
        :options="editorOption"

        @change="onEditorChange($event)"
      />
  <!--   @blur="onEditorBlur($event)"
        @focus="onEditorFocus($event)" -->
        <el-upload
              drag
              multiple
              class="quill-upload"
              :on-success="quillSuccess"
              :action="$uploadURL"
            >
              <!-- <el-button size="small" type="primary">点击上传</el-button> -->
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或
                <em>点击上传</em>
              </div>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
            </el-upload>
    </div>
  </template>

<script>

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'

export default {
  components: { quillEditor },
  props: {
    propsContent: {
      type: String,
      required: true
    }
  },
  watch: {
    propsContent: {
      handler (val) {
        this.content = val // 监听父组件的数据，同步更新子组件数据
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      content: ``, // 双向数据绑定数据
      // 富文本编辑器配置
      editorOption: {
        placeholder: '请输入正文',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
              ['blockquote', 'code-block'], // 引用  代码块
              [{ header: 1 }, { header: 2 }], // 1、2 级标题 标题，键值对的形式；1、2表示字体大小
              [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
              [{ script: 'sub' }, { script: 'super' }], // 上标/下标
              [{ indent: '-1' }, { indent: '+1' }], // 缩进
              // [{ direction: 'rtl' }], // 文本方向
              // [{ size: ['12px', false, '16px', '18px', '20px', '30px'] }], // 字体大小
              [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
              [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
              [
                // { font: [false, 'SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial'] }
              ], // 字体种类
              [{ align: [] }], // 对齐方式
              ['clean'], // 清除文本格式
              ['link', 'image', 'video'] // 链接、图片、视频
            ],
            handlers: {
              // 重写点击组件上的图片按钮要执行的代码
              'image': function (value) {
                document.querySelector('.quill-upload .el-icon-upload').click()
              }
            }
          }
        }
      }
      // currentLnegth: 0,
      // limitLength: 500
    }
  },

  methods: {
    // 失去焦点事件
    onEditorBlur (quill) {
      // console.log('editor blur!', quill);
    },
    // 获得焦点事件
    onEditorFocus (quill) {
      // console.log('editor focus!', quill);
    },
    // 准备富文本编辑器
    onEditorReady (quill) {
      // console.log('editor ready!', quill);
    },
    // 内容改变事件
    onEditorChange ({ quill, html, text }) {
      this.$emit('contentChange', html)
    },
    quillSuccess (response) {
      if (response) {
        // 获取文本编辑器
        const quill = this.$refs.myQuillEditor.quill
        // 获取光标位置
        const pos = quill.getSelection().index
        // 插入图片到光标位置
        quill.insertEmbed(pos, 'image', response.data.url)
      } else {
        this.$essage.error('图片插入失败')
      }
    }
  }
}
</script>

  <style lang="scss" scoped>
/deep/ .quill-editor {
  height: 230px; /* or any other desired height */
  overflow-y: hidden;
  padding: 0px;
}
/deep/  .ql-editor{
  padding: 0px;
      width: 55vw;
      height: 530px;
}
  .quill-editor /deep/ .ql-container {
    width: 55vw;
    height: 530px;

  }
  /deep/ .ql-editor {
  overflow-x: auto;
  scrollbar-width: thin;
  scrollbar-color: #ccc #f1f1f1;
}

/deep/ .ql-editor::-webkit-scrollbar {
  height: 8px;
}

/deep/ .ql-editor::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 4px;
}

/deep/ .ql-editor::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
  .ql-container {
    width: 55vw;
    min-height: 230px;
  }
  .quill-upload{
    display: none;
  }
  </style>
